import listNacionalni from '../assets/vesti/nacionalni-kongres-list.jpg';
import detailNacionalni from '../assets/vesti/nacionalni-kongres-detail.jpg';
import listSimpozijum from '../assets/vesti/simpozijum-oftalmoloski-dani-list.jpg';
import detailSimpozijum from '../assets/vesti/simpozijum-oftalmoloski-dani-detail.jpg';
import listGlaukom from '../assets/beomedica_sajam.jpg';
import detailGlaukom from '../assets/beomedica_sajam.jpg';

/** Newest first */
export const VESTI = [
  {
    slug: 'kongres-glaukomatologa',
    date: '2026-05-07',
    imageList: listGlaukom,
    imageDetail: detailGlaukom,
  },
  {
    slug: 'simpozijum-oftalmoloski-dani',
    date: '2026-04-25',
    imageList: listSimpozijum,
    imageDetail: detailSimpozijum,
  },
  {
    slug: 'nacionalni-kongres',
    date: '2025-10-30',
    imageList: listNacionalni,
    imageDetail: detailNacionalni,
  },
];

export function getVestBySlug(slug) {
  return VESTI.find((v) => v.slug === slug);
}
